import { render, staticRenderFns } from "./DevicesOnTest.vue?vue&type=template&id=4c24bbdd&scoped=true"
import script from "./DevicesOnTest.vue?vue&type=script&lang=ts"
export * from "./DevicesOnTest.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c24bbdd",
  null
  
)

export default component.exports